import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { MdEdit } from 'react-icons/md';
import PageHeading from '../ReusableComponents/PageHeading';
import SectionButtons from '../ReusableComponents/SectionButtons';
import SectionContentHeading from '../ReusableComponents/SectionContentHeading';
import DefaultButton from '../ReusableComponents/DefaultButton';
import OrganizationDetails from './OrganizationDetails';
import OrganizationLogo from './OrganizationLogo';
import Integrations from './Integrations';
import { useMyOrganization } from './hooks';
import { ErrorNotice, Loading, Success } from '../PortalAluno/components/Feedback';
import '../ReusableComponents/ModulePage.css';
import '../PortalAluno/portal.css';
const modules = [
  {
    value: 'dados',
    label: 'Dados institucionais',
    description: 'Identificação, contato e identidade visual.',
    icon: 'processos',
  },
  {
    value: 'integracoes',
    label: 'Integrações',
    description: 'Credenciais da API e conexão com o portal.',
    icon: 'configuracoes',
  },
];
export default function MinhaOrganizadora() {
  const query = useMyOrganization(),
    location = useLocation(),
    history = useHistory();
  const params = new URLSearchParams(location.search),
    selected = params.get('modulo') === 'integracoes' ? 'integracoes' : 'dados',
    o = query.data;
  return (
    <div className="module-page module-details portal-admin">
      <section className="card module-card hidethis">
        <div className="card-body">
          <div className="portal-admin-row">
            <PageHeading
              title="Minha organizadora"
              description="Consulte os dados da sua organizadora e gerencie suas integrações."
              leading={<OrganizationLogo src={o?.logo_url} alt={o?.name} variant="heading" />}
            />
          </div>
          {o && <p className="text-muted mb-0">{o.name}</p>}
        </div>
      </section>
      <section className="card module-card detail-summary hidethis">
        <div className="card-body">
          <h2 className="module-selector-title">Escolha um módulo para gerenciar</h2>
          <SectionButtons
            compact
            variant="modules"
            items={modules}
            value={selected}
            onChange={(value) => {
              params.set('modulo', value);
              params.delete('salvo');
              history.push({ pathname: location.pathname, search: params.toString() });
            }}
          />
        </div>
      </section>
      <ErrorNotice error={query.error} />
      {query.isLoading ? (
        <Loading />
      ) : (
        o && (
          <>
            <Success show={params.get('salvo') === '1'}>Dados da organizadora atualizados.</Success>
            {selected === 'integracoes' ? (
              <Integrations organization={o} />
            ) : (
              <section className="card module-card module-content">
                <div className="card-body">
                  <div className="portal-admin-row">
                    <SectionContentHeading items={modules} value={selected} />
                    {o.can_edit && (
                      <DefaultButton
                        text="Editar dados"
                        bg="info"
                        icon={<MdEdit />}
                        to="/minha-organizadora/editar"
                      />
                    )}
                  </div>
                  <OrganizationDetails organization={o} />
                </div>
              </section>
            )}
          </>
        )
      )}
    </div>
  );
}
